module.exports = __webpack_public_path__ + "img/7.43ada631.png";